import {useEffect, useState} from 'react';

import useMountEffect from '@patientpattern/utils/hooks/useMountEffect';
import usePrevious from '@patientpattern/utils/hooks/usePrevious';
import {useLocation} from 'react-router-dom';

import useAnalytics from './useAnalytics';

import {useUserStore} from 'user/store';

export default function usePageTracking() {
    const {init, identify, register, reset, track} = useAnalytics();
    const {pathname} = useLocation();
    const [isInitialized, setIsInitialized] = useState(false);
    const id = useUserStore(state => state.id);
    const prevId = usePrevious(id);

    useMountEffect(() => {
        init(import.meta.env.HAL_MIXPANEL_TOKEN);
        register({
            Environment: import.meta.env.HAL_ENVIRONMENT,
            Product: 'Care Coach',
        });

        setIsInitialized(true);
    });

    useEffect(() => {
        if (id !== prevId) {
            reset();
            identify(id);
        }
    }, [id, prevId, identify, reset]);

    useEffect(() => {
        if (isInitialized) {
            track('View Page');
        }
    }, [pathname, isInitialized, track]);
}
